/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_CreatedInputs */

const vi_notif_type_created = /** @type {(inputs: Notif_Type_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng mới`)
};

/**

* @param {Notif_Type_CreatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_created = /** @type {((inputs?: Notif_Type_CreatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_CreatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_created(inputs)
});